<app-detect-language-change></app-detect-language-change>

@if (isGlobalOverlayLoading()) {

  <div class="my-loading-progress-g layout-global-loading" role="status" aria-live="polite">

    <div class="loading-progress-g"></div>

  </div>

}

<app-header-page [currentPage]="currentPage()" [routeBackPage]="routeBackPage()" [bell]="bell()"></app-header-page>

<div class="container-fluid p-0">

  <div class="row justify-content-start no-gutters layout-main-row">



    @if (showMobileNavbar()) {

    <div class="col-12 col-md-3 col-lg-2 d-block d-md-none">

      <div class="bar-adjustment-container">

        <app-navbar></app-navbar>

      </div>

    </div>

    }

    <div class="col layout-content-col" [@routeAnimation]="getAnimationData()">

      <router-outlet></router-outlet>

    </div>



  </div>

</div>

